import { Component, Input } from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { COMMONS } from '../../utils/commons.constants';

@Component({
  selector: 'ms-table-paged-footer',
  templateUrl: './table-paged-footer.component.html',
  styleUrls: ['./table-paged-footer.component.scss'],
})
export class TablePagedFooterComponent {
  @Input() page: VonPageResponseModel<any> = {
    content: [],
    last: true,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0,
  };
  readonly paginationText = COMMONS.paginationText;
}
